import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

interface ExamManagementContextValue {
  readonly examId: number | null;
  readonly isCreating: boolean;
}

const ExamManagementContext = createContext<ExamManagementContextValue | null>(null);
ExamManagementContext.displayName = 'ExamManagementContext';

export function useExamManagement(): ExamManagementContextValue {
  const ctx = useContext(ExamManagementContext);
  if (!ctx) throw new Error('useExamManagement must be used within <ExamManagementProvider>');
  return ctx;
}

export function ExamManagementProvider({
  examId,
  isCreating,
  children,
}: PropsWithChildren<ExamManagementContextValue>) {
  const value = useMemo(() => ({ examId, isCreating }), [examId, isCreating]);
  return <ExamManagementContext.Provider value={value}>{children}</ExamManagementContext.Provider>;
}
